import DatePicker from './DatePicker';
import withForm from '../Form/withForm';

const WrappedDatePicker = withForm(DatePicker);
WrappedDatePicker.convertDateToISO = DatePicker.convertDateToISO;

export default WrappedDatePicker;
